import { Action } from 'redux';
import { Video } from '../../../models/Entities/Turnero';
import { TurneroVideosState, TurneroVideosUnloadState } from '../../states/Turnero-Videos.State';

export default function TurneroVideosReducer(
    state: TurneroVideosState | undefined,
    action: Action
): TurneroVideosState {
    const currentState = state ?? TurneroVideosUnloadState;
    const a: any = action;

    switch (a.type) {
        case 'TURNERO-VIDEOS_GET_ALL_REQUEST':
            return {
                ...currentState,
                isLoadingAll: true,
                successLoadingAll: false,
                failOnLoadingAll: false,
                error: undefined
            } as TurneroVideosState;
        case 'TURNERO-VIDEOS_GET_ALL_SUCCESS':
            return {
                ...currentState,
                isLoadingAll: false,
                successLoadingAll: true,
                failOnLoadingAll: false,
                error: undefined,
                list: a.payload || []
            } as TurneroVideosState;
        case 'TURNERO-VIDEOS_GET_ALL_FAILURE':
            return {
                ...currentState,
                isLoadingAll: false,
                successLoadingAll: false,
                failOnLoadingAll: true,
                error: a.error
            } as TurneroVideosState;

        case 'TURNERO-VIDEOS_CREATE_REQUEST':
            return {
                ...currentState,
                isAddingNewOne: true,
                successAddingNewOne: false,
                failOnAddingNewOne: false,
                error: undefined
            } as TurneroVideosState;
        case 'TURNERO-VIDEOS_CREATE_SUCCESS':
            return {
                ...currentState,
                isAddingNewOne: false,
                successAddingNewOne: true,
                failOnAddingNewOne: false,
                error: undefined,
                list: [...(currentState.list || []), a.payload]
            } as TurneroVideosState;
        case 'TURNERO-VIDEOS_CREATE_FAILURE':
            return {
                ...currentState,
                isAddingNewOne: false,
                successAddingNewOne: false,
                failOnAddingNewOne: true,
                error: a.error
            } as TurneroVideosState;

        case 'TURNERO-VIDEOS_UPDATE_REQUEST':
            return {
                ...currentState,
                isUpdatingOne: true,
                successUpdatingOne: false,
                failOnUpdatingOne: false,
                error: undefined
            } as TurneroVideosState;
        case 'TURNERO-VIDEOS_UPDATE_SUCCESS':
            return {
                ...currentState,
                isUpdatingOne: false,
                successUpdatingOne: true,
                failOnUpdatingOne: false,
                error: undefined
            } as TurneroVideosState;
        case 'TURNERO-VIDEOS_UPDATE_FAILURE':
            return {
                ...currentState,
                isUpdatingOne: false,
                successUpdatingOne: false,
                failOnUpdatingOne: true,
                error: a.error
            } as TurneroVideosState;

        case 'TURNERO-VIDEOS_DELETE_REQUEST':
            return {
                ...currentState,
                isDeletingOne: true,
                successDeletingOne: false,
                failOnDeletingOne: false,
                error: undefined
            } as TurneroVideosState;
        case 'TURNERO-VIDEOS_DELETE_SUCCESS':
            return {
                ...currentState,
                isDeletingOne: false,
                successDeletingOne: true,
                failOnDeletingOne: false,
                error: undefined,
                list: (currentState.list || []).filter((v: Video) => v.id !== a.payload)
            } as TurneroVideosState;
        case 'TURNERO-VIDEOS_DELETE_FAILURE':
            return {
                ...currentState,
                isDeletingOne: false,
                successDeletingOne: false,
                failOnDeletingOne: true,
                error: a.error
            } as TurneroVideosState;

        default:
            return currentState as TurneroVideosState;
    }
}
